<template>
    <div class="modal-wrapper" @click="close">
		<div class="modal-container modal-container-mini" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12 col-lg-12">
						GERENCIAR PERCURSOS
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body modal-body-mini">
                <div class="row">
                    <div class="col-xs-12">
                        <p class="table-text-label">Selecione os percursos <span v-popover:tooltip.right="'Selecione os percursos a serem ativados/inativados. Os percursos marcados são considerados ativos e os desmarcados inativos.'"><i class="fas fa-question-circle"></i></span></p>
                    </div>
                    <div class="col-xs-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <span class="input-checkbox" @click="onSelectAll()"><i :class="select_all ? 'fas fa-check-square' : 'far fa-square'"></i></span>
                                    </th>
                                    <th scope="col">Percurso</th>
                                    <th scope="col">Código</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in my_courses" :key="index">
                                    <td>
                                        <span class="input-checkbox" @click="onSelect(item)"><i :class="item.status ? 'fas fa-check-square' : 'far fa-square'"></i></span>
                                    </td>
                                    <td>{{ item.course }}</td>
                                    <td>{{ item.code }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
			<div class="modal-footer">
                <div class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="back" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-caret-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="my_courses.length == 0 || loading" @click="confirm">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-check'"></i> CONFIRMAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Api from "@/lib/Api";

    export default {
        name: "RoutingModalManageCourses",

        props: {
        },

        components: { 
        },

        data: function() {
            return {
                loading: false,
                my_courses: [],
                form: {
                    courses: "",
                },
                select_all: true,
                has_selected: true,
            }
        },
        
        beforeMount: async function() {
            await this.load();
        },

        methods: {
            load: async function() {
                let result = null;

                this.loading = true;
                try {
                    result = await Api.post("delivery-course/list-all-courses");
                } catch(ex) {
                    console.log(ex);

                    this.loading = false;
                    this.$notification.error("Não foi possível obter a lista de percursos.");
                    
                    return;
                }
                
                this.loading = false;
                
                if(result) {
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            this.$notification.error(result.data);
                            return;
                        }
                    } else {
                        this.my_courses = result.data;
                        if (this.my_courses.length > 0) {
                            this.my_courses.map(value => {
                                value.status = value.status ? true : false;
                                if (!value.status) {
                                    this.select_all = false;
                                }
                            });
                        } else {
                            this.select_all = false;
                        }
                        return;
                    }
                } else {
                    this.$notification.error("Não foi possível obter a lista de percursos.");
                    return;
                }
            },
            
            onSelectAll: function() {
                if (this.my_courses.length > 0) {
                    this.select_all = !this.select_all;
                    this.my_courses.map(item => {
                        item.status = this.select_all;
                    });
                }
            },

            onSelect: function(item) {
                item.status = !item.status;
                this.checkAllStatus();
            },

            checkAllStatus: function() {
                let selected = 0;
                this.my_courses.map(item => {
                    if (item.status == true) selected++;
                });
                this.select_all = this.my_courses.length == selected ? true : false;
            },

            // Envia os dados e fecha o modal
            confirm: async function() {
                let result = await this.save();

                if (result) {
                    let list_my_courses = [];
                    this.my_courses.forEach(element => {
                        if (element.status) list_my_courses.push(element);
                    });
                    this.$emit("confirm", list_my_courses);
                }
            },

            // Envia para API e salva as informações no BD e XML
            save: async function() {
                let form = {};
                form.courses = this.my_courses;
                
                let result = null;

                this.loading = true;
                try {
                    result = await Api.post("delivery-course/update-status", form);
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível processar as informações.");
                    this.loading = false;
                    return false;
                }
                this.loading = false;

                // Verifica se houve erro
                if(result.error) {
                    if (result.data == "unauthorized") {
                        // Notifica o fim da sessão
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        // Notifica o erro
                        this.$notification.error(result.data);
                        return false;
                    }
                } else {
                    return true;
                }
            },

            // Volta para o modal anterior
            back: function() {
                this.$emit("back");
            },

            // Fecha o modal
            close: function() {
                this.$emit("close");
            },
        }
    }
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 700px;
	height: 440px;
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 330px;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-research {
	float: right;
    margin-right: 15px;
	background: #fff;
	border: 2px solid #222 !important;
    color: #222;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-research:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 229px;
    line-height: 229px;
}

.loading-icon, 
.loading-percent {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}

table { 
	width: 100%;
	border-collapse: collapse;
    border: 1px solid #eee;
}

th { 
	background: #fff;
    text-align: left;
    padding: 10px;
    font-size: 14px;
    font-size: small;
}

td, th { 
	padding: 10px; 
	border-top: 1px solid #f0f0f0; 
	text-align: left; 
	font-size: 14px;
}
tr td:first-child, tr th:first-child { 
    text-align: center;
}

tr:last-child td, tr:last-child th { 
	border-bottom: 1px solid #f0f0f0; 
}

tr:hover td {
    background: #eee;
}

.table-text-label {
    margin-top: 0px;
}

.input-checkbox {
    cursor: pointer;
    font-size: 15px;
}
</style>